import { useTranslations } from "next-intl";
import { createPortal } from "react-dom";

import animations from "@/lib/utils/animations";
import ArrowSvg from "@/public/svg/Arrow.svg";
import CheckSvg from "@/public/svg/check.svg";
import type { ISortOrder } from "@/types/centra";

import styles from "./sortMenu.module.scss";
interface SortMenuProps {
  toggleMenu: () => void;
  closeMenu: () => void;
  show: boolean;
  sortOrder: ISortOrder;
  shouldRender: boolean;
}

const UI = ({ toggleMenu, show, sortOrder, shouldRender }: SortMenuProps) => {
  const t = useTranslations();

  const temp_i18n = {
    newest: t("newest"),
    price: t("price"),
    nameAsc: t("nameAZ"),
    nameDesc: t("nameZA"),
    lowestPrice: t("lowestPrice"),
    highestPrice: t("highestPrice"),
    default: t("mostPopular"),
  };
  return (
    <div className={styles.container}>
      <div className={styles.sortMenu}>
        <div
          onClick={toggleMenu}
          className={`${styles.button}  ${(show && styles.activeMenu) || ""}`}
        >
          {sortOrder.active && <p>{temp_i18n[sortOrder.active.key]}</p>}
          <ArrowSvg />
        </div>
        {shouldRender && (
          <>
            {createPortal(
              <div className={styles.overlay} onClick={toggleMenu} />,
              document.body
            )}
            <span
              className={`${styles.dropdown} ${show ? styles.activeMenu : ""}`}
              style={animations("fade", show)}
            >
              {sortOrder.options.map((sort) => (
                <button
                  className={`${styles.item} ${sort.active && styles.selected}`}
                  onClick={sort.setFunction}
                  key={sort.key}
                >
                  {temp_i18n[sort.key]}

                  {sort.active && <CheckSvg />}
                </button>
              ))}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default UI;
